import { Container } from "reactstrap";
import { useState } from "react";
import Breadcrumbs from "../../../common-elements/breadcrumbs/Breadcrumbs";
import { useTranslation } from "react-i18next";
import { SMSData } from "./types/types";
import SMSRightSide from "./sms-right-side/SMSRightSide";

const SMSBoxContainer = () => {
  const { t } = useTranslation();
  const [composeSMS, setComposeSMS] = useState(false);
  const [smsValidation, setSMSValidation] = useState(false);
  const [searchWord, setSearchWord] = useState("");
  const [smsMessages, setSMSMessages] = useState<SMSData[]>([
    {
      id: "11",
      recipientRoles: ["Developers", "Admins"],
      message: "Server Maintenance Alert",
      description: "Scheduled for 1:00 AM to 3:00 AM IST tomorrow.",
      time: "11:50 AM",
      status: "sent",
      priority: [{ title: "High", color: "danger" }],
    },
    {
      id: "12",
      recipientRoles: ["Sales", "Team A"],
      message: "System Update Notification",
      description: "New API endpoints available today.",
      time: "12:00 PM",
      status: "delivered",
      priority: [{ title: "Medium", color: "info" }],
    },
    {
      id: "13",
      recipientRoles: ["Team B", "Managers"],
      message: "Security Patch Alert",
      description: "Apply updates by 6:00 PM IST.",
      time: "12:10 PM",
      status: "pending",
      priority: [{ title: "High", color: "danger" }],
    },
    {
      id: "14",
      recipientRoles: ["Developers", "Sales"],
      message: "Database Optimization Notice",
      description: "Expect minor delays this evening.",
      time: "12:20 PM",
      status: "sent",
      priority: [{ title: "Medium", color: "warning" }],
    },
    {
      id: "15",
      recipientRoles: ["Team A", "Team B"],
      message: "Platform Feedback Request",
      description: "Share system issues via the portal.",
      time: "12:30 PM",
      status: "delivered",
      priority: [{ title: "Low", color: "light" }],
    },
    {
      id: "16",
      recipientRoles: ["Developers"],
      message: "API Rate Limit Increase",
      description: "Effective from 8:00 AM IST tomorrow.",
      time: "12:40 PM",
      status: "sent",
      priority: [{ title: "Medium", color: "info" }],
    },
    {
      id: "17",
      recipientRoles: ["Sales", "Team A"],
      message: "Service Upgrade Notice",
      description: "Improved performance starting next week.",
      time: "12:50 PM",
      status: "delivered",
      priority: [{ title: "Medium", color: "warning" }],
    },
    {
      id: "18",
      recipientRoles: ["Team B", "Managers"],
      message: "System Downtime Alert",
      description: "Brief outage at 11:00 PM IST tonight.",
      time: "1:00 PM",
      status: "pending",
      priority: [{ title: "High", color: "danger" }],
    },
    {
      id: "19",
      recipientRoles: ["Developers", "Sales"],
      message: "New Feature Rollout",
      description: "Check the updated UI at 2:00 PM IST.",
      time: "1:10 PM",
      status: "sent",
      priority: [{ title: "High", color: "danger" }],
    },
    {
      id: "20",
      recipientRoles: ["Admins", "Managers"],
      message: "Security Audit Reminder",
      description: "Complete checks by end of day.",
      time: "1:20 PM",
      status: "delivered",
      priority: [{ title: "High", color: "danger" }],
    },
    {
      id: "21",
      recipientRoles: ["Developers", "Admins"],
      message: "Bug Fix Deployment",
      description: "Live at 3:00 PM IST today.",
      time: "1:30 PM",
      status: "sent",
      priority: [{ title: "Medium", color: "info" }],
    },
    {
      id: "22",
      recipientRoles: ["Sales", "Team A"],
      message: "Analytics Dashboard Update",
      description: "New metrics available tomorrow.",
      time: "1:40 PM",
      status: "delivered",
      priority: [{ title: "Low", color: "light" }],
    },
    {
      id: "23",
      recipientRoles: ["Team A", "Team B"],
      message: "Load Balancer Upgrade",
      description: "No downtime expected.",
      time: "1:50 PM",
      status: "sent",
      priority: [{ title: "Medium", color: "warning" }],
    },
    {
      id: "24",
      recipientRoles: ["Developers", "Sales"],
      message: "Webhook Configuration Change",
      description: "Review settings by 5:00 PM IST.",
      time: "2:00 PM",
      status: "pending",
      priority: [{ title: "High", color: "danger" }],
    },
    {
      id: "25",
      recipientRoles: ["Developers"],
      message: "Deprecation Notice",
      description: "Legacy API endpoints retire next month.",
      time: "2:10 PM",
      status: "sent",
      priority: [{ title: "Medium", color: "info" }],
    },
  ]);

  const handleAddSMS = (newSMS: {
    recipientRoles: string;
    message: string;
    description: string;
  }) => {
    setSMSMessages([
      ...smsMessages,
      {
        id: `${smsMessages.length + 1}`,
        recipientRoles: newSMS.recipientRoles
          .split(",")
          .map((role) => role.trim()),
        message: newSMS.message,
        description: newSMS.description.substring(0, 50),
        time: new Date().toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        }),
        status: "pending",
        priority: [{ title: "Low", color: "light" }],
      },
    ]);
    setComposeSMS(false);
    setSMSValidation(false);
  };
  return (
    <>
      <Breadcrumbs mainTitle={t("SMS")} parent={t("Communication")} />
      <Container fluid>
        <SMSRightSide
          composeSMS={composeSMS}
          setComposeSMS={setComposeSMS}
          smsValidation={smsValidation}
          setSMSValidation={setSMSValidation}
          searchWord={searchWord}
          setSearchWord={setSearchWord}
          smsMessages={smsMessages}
          handleAddSMS={handleAddSMS}
        />
      </Container>
    </>
  );
};

export default SMSBoxContainer;
